import {ACTION_TYPES} from './constants';

export const getIntegrationWorkbooks = (workbooks: any[] | null, integrationId: string) => {
  /*
   * From a list of all workbooks available, return only those that are
   *   associated with the given integration.
   */
  return (workbooks || []).filter(w => w.integrationUid === integrationId);
}

export const getWorkbookViews = (views: any[] | null, integrationId: string, workbookId: string) => {
  /*
   * From a list of all views available, return only those that are
   *   associated with the given integration & workbook.
   */
  return (views || []).filter(v => v.integrationUid === integrationId && v.workbookId === workbookId);
}

export const getViewCustomViews = (customViews: any[] | null, integrationId: string, viewId: string) => {
  /*
   * From a list of all custom views available, return only those that are
   *   associated with the given integration & view.
   */
  return (customViews || []).filter(cv => cv.integrationUid === integrationId && cv.view_id === viewId);
}

export const tableauItemsToOptions = (items: any[]) => {
  return items?.map((item: any) => ({
    label: item.name,
    value: item.id,
    secondary_label: item.project_name,
  })) || [];
}

export const getFileType = (action: string) => {
  switch (action) {
    case ACTION_TYPES.WORKBOOK_PDF:
    case ACTION_TYPES.VIEW_PDF:
      return 'pdf';
    case ACTION_TYPES.VIEW_CSV:
      return 'csv';
    case ACTION_TYPES.VIEW_IMAGE:
      return 'png';
    case ACTION_TYPES.VIEW_EXCEL:
    case ACTION_TYPES.VIEW_CROSSTAB:
      return 'xlsx';
    case ACTION_TYPES.WORKBOOK_POWERPOINT:
      return 'pptx';
    default:
      return 'no_type'; // null
  }
};

export const createDefaultOption = (label: string, value: string) => {
  /*
   * Only add default option if both label and value are present.
   */
  const option = {
    label,
    value,
    secondary_label: '',
  };

  if (!label || !value) {
    return [];
  }
  return [option];
}

export const createDefaultContent = (
  integrationId: string | null = null,
  action: string = ACTION_TYPES.WORKBOOK_PDF,
  embed: boolean = true,
) => {
  return {
    integration_id: integrationId,
    workbook_id: '',
    view_id: '',
    custom_view_id: '',
    action: action,
    export_options: {
      embed,
      delimiter: '',
      quote_char: '',
      datatypes_parsing: '',
      column_properties: {},
      workbook_locale: '',
    },
  };
}

export const showOptionsFor = (currentAction: any, shouldBeAction: any) => {
  /*
   * Show the options for the given action.
   */
  return currentAction === shouldBeAction;
};
